import React, { useState } from 'react';
import { useLocation } from "react-router-dom";
import { Button, Snackbar, Typography, Chip, CardActions } from '@mui/joy';
import { Card, Divider, Box, Radio, RadioGroup } from '@mui/joy';

import { KeyboardArrowRight, Report } from '@mui/icons-material';

import LoadingSpinnerComponent from '../LoadingSpinnerComponent';
import { cardStyles } from '../../styles/cardStyles';

import '../../styles/reviews.scss';

const networking = require('../../Networking/API');
const helper = require('../../Helpers/helpers');

function PlanManagementComponent({ subscription, onSubscriptionUpdate }: any) {
    const location = useLocation();

    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [showError, setShowError] = useState(false);
    const [showSuccess, setShowSuccess] = useState(false);
    const [selectedMode, setselectedMode] = useState("yearly");

    const updateToPlan = (plan: any) => {
        const planCode = plan.code;
        const payMode = selectedMode === 'monthly' ? 0 : 1;

        setLoading(true);
        networking.checkoutSubscription(planCode, payMode, location.pathname, subscription.id).then((data: any) => {
            setLoading(false);
            localStorage.setItem("savedState", JSON.stringify(location.state));
            window.location.href = data.checkout_url;
        }).catch((error: Error) => {
            setLoading(false);
            setShowError(true);
            setError(error.message);
        });
    }

    const modeLabel = selectedMode === "mo"

    return (
        <>
            {showError &&
                <Snackbar
                    variant="soft"
                    color="danger"
                    open={showError}
                    onClose={() => setShowError(false)}
                    anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                    startDecorator={<Report />}
                    endDecorator={
                        <Button
                            onClick={() => setShowError(false)}
                            size="sm"
                            variant="soft"
                            color="danger"
                        >
                            Dismiss
                        </Button>
                    }
                >
                    {error}
                </Snackbar>
            }
            {showSuccess &&
                <Snackbar
                    variant="soft"
                    color="success"
                    open={showSuccess}
                    onClose={() => setShowSuccess(false)}
                    anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                    startDecorator={<Report />}
                    endDecorator={
                        <Button
                            onClick={() => setShowSuccess(false)}
                            size="sm"
                            variant="soft"
                            color="success"
                        >
                            Dismiss
                        </Button>
                    }
                >
                    Profile updated! 🚀
                </Snackbar>
            }
            {loading ?
                <LoadingSpinnerComponent />
                :
                <>
                    <div className='row gx-2 gy-2'>
                        <div className='col'>
                            <Card
                                size="lg"
                                color="neutral"
                                sx={{
                                    ...cardStyles.elevated
                                }}>
                                {subscription.plan === helper.planAA.code &&
                                    <div className='flex flex-col space-y-2'>
                                        <Chip
                                            size="sm"
                                            variant="solid"
                                            color="primary"
                                            sx={{
                                                marginRight: 1
                                            }}>
                                            ✅ Current plan
                                        </Chip>
                                        <Chip
                                            size="sm"
                                            variant="solid"
                                            color="neutral">
                                            {subscription.billing_cycle}
                                        </Chip>
                                    </div>
                                }
                                <Typography level="h2">
                                    {helper.planAA.name}
                                    <span
                                        style={{ marginLeft: 8, fontSize: "14px" }}>
                                        | Listen
                                    </span>
                                </Typography>
                                <Typography level="body-sm">{helper.planAA.description}</Typography>
                                <Typography level="h2">
                                    {helper.planAA.priceMonth}{'€'}{' '}
                                    <Typography textColor="text.tertiary" sx={{ fontSize: 'sm' }}>
                                        / {modeLabel}
                                    </Typography>
                                    <p>
                                        <Typography
                                            textColor="text.tertiary"
                                            sx={{ fontSize: '12px' }}>
                                            Billed annually → €460/yr
                                        </Typography>
                                    </p>
                                </Typography>
                                <div
                                    className='text-center'
                                    style={{
                                        padding: '12px',
                                        display: 'inline-block',
                                        borderRadius: 8,
                                        backgroundColor: '#f5f5f5',
                                        border: '1px solid #e0e0e0'
                                    }}>
                                    <Typography
                                        level='body-sm'
                                        fontWeight="bold">
                                        up to 3 seats
                                    </Typography>
                                </div>
                                <Divider inset="none" />
                                <Typography
                                    level='body-sm'
                                    fontWeight="bold">
                                    All Starter features, including:
                                </Typography>
                                <ul className="">
                                    {helper.planAA.features.map((feature: any) =>
                                        <li key={feature}>
                                            <Typography
                                                level='body-sm'>
                                                {feature}
                                            </Typography>
                                        </li>
                                    )}
                                </ul>
                                {subscription.plan !== helper.planAA.code &&
                                    <>
                                        <Divider inset="none" />
                                        <Box
                                            sx={{ display: 'flex', justifyContent: 'left', mb: 2, color: '#c5c5c5' }}>
                                            <RadioGroup
                                                value={selectedMode}
                                                onChange={(event) => setselectedMode(event.target.value)}
                                                orientation="horizontal"
                                                sx={{ gap: 3 }}
                                            >
                                                <Radio value="yearly" label="Yearly" size="sm" sx={{ fontWeight: 'medium' }} />
                                                <Radio value="monthly" label="Monthly" size="sm" sx={{ fontWeight: 'medium' }} />
                                            </RadioGroup>
                                        </Box>
                                        <CardActions>
                                            <Button
                                                onClick={() => updateToPlan(helper.planAA)}
                                                endDecorator={<KeyboardArrowRight />}>
                                                Update plan
                                            </Button>
                                        </CardActions>
                                    </>
                                }
                            </Card>
                        </div>
                        <div className='col'>
                            <Card
                                size="lg"
                                color="neutral"
                                sx={{
                                    ...cardStyles.base
                                }}>
                                {subscription.plan === helper.planAAA.code &&
                                    <div className='flex flex-col space-y-2'>
                                        <Chip
                                            size="sm"
                                            variant="solid"
                                            color="primary"
                                            sx={{
                                                marginRight: 1
                                            }}>
                                            ✅ Current plan
                                        </Chip>
                                        <Chip
                                            size="sm"
                                            variant="solid"
                                            color="neutral">
                                            {subscription.billing_cycle}
                                        </Chip>
                                    </div>
                                }
                                <Typography level="h2">
                                    {helper.planAAA.name}
                                    <span
                                        style={{ marginLeft: 8, fontSize: "14px" }}>
                                        | Act
                                    </span>
                                </Typography>
                                <Typography level="body-sm">{helper.planAAA.description}</Typography>
                                <Typography level="h2">
                                    {helper.planAAA.priceMonth}{'€'}{' '}
                                    <Typography textColor="text.tertiary" sx={{ fontSize: 'sm' }}>
                                        / {modeLabel}
                                    </Typography>
                                    <p>
                                        <Typography
                                            textColor="text.tertiary"
                                            sx={{ fontSize: '12px' }}>
                                            Billed annually → €1334/yr
                                        </Typography>
                                    </p>
                                </Typography>
                                <div
                                    className='text-center'
                                    style={{
                                        padding: '12px',
                                        display: 'inline-block',
                                        borderRadius: 8,
                                        backgroundColor: '#f5f5f5',
                                        border: '1px solid #e0e0e0'
                                    }}>
                                    <Typography
                                        level='body-sm'
                                        fontWeight="bold">
                                        up to 5 seats
                                    </Typography>
                                </div>
                                <Divider inset="none" />
                                <Typography
                                    level='body-sm'
                                    fontWeight="bold">
                                    All Starter features, plus:
                                </Typography>
                                <ul className="">
                                    {helper.planAAA.features.map((feature: any) =>
                                        <li key={feature}>
                                            <Typography
                                                level='body-sm'>
                                                {feature}
                                            </Typography>
                                        </li>
                                    )}
                                </ul>
                                {subscription.plan !== helper.planAAA.code &&
                                    <>
                                        <Divider inset="none" />
                                        <Box
                                            sx={{ display: 'flex', justifyContent: 'left', mb: 2, color: '#c5c5c5' }}>
                                            <RadioGroup
                                                value={selectedMode}
                                                onChange={(event) => setselectedMode(event.target.value)}
                                                orientation="horizontal"
                                                sx={{ gap: 3 }}
                                            >
                                                <Radio value="yearly" label="Yearly" size="sm" sx={{ fontWeight: 'medium' }} />
                                                <Radio value="monthly" label="Monthly" size="sm" sx={{ fontWeight: 'medium' }} />
                                            </RadioGroup>
                                        </Box>
                                        <CardActions>
                                            <Button
                                                onClick={() => updateToPlan(helper.planAAA)}
                                                endDecorator={<KeyboardArrowRight />}>
                                                Update plan
                                            </Button>
                                        </CardActions>
                                    </>
                                }
                            </Card>
                        </div>
                        <div className='col'>
                            <Card
                                size="lg"
                                color="neutral"
                                sx={{
                                    ...cardStyles.base
                                }}>
                                {subscription.plan === helper.planU.code &&
                                    <Chip size="sm" variant="solid" color="primary">
                                        Current plan
                                    </Chip>
                                }
                                <Typography level="h2">
                                    {helper.planU.name}
                                    <span
                                        style={{ marginLeft: 8, fontSize: "14px" }}>
                                        | Capture
                                    </span>
                                </Typography>
                                <Typography level="body-sm">{helper.planU.description}</Typography>
                                <div
                                    className='text-center'
                                    style={{
                                        padding: '12px',
                                        display: 'inline-block',
                                        borderRadius: 8,
                                        backgroundColor: '#f5f5f5',
                                        border: '1px solid #e0e0e0'
                                    }}>
                                    <Typography
                                        level='body-sm'
                                        fontWeight="bold">
                                        up to 10 seats
                                    </Typography>
                                </div>
                                <Divider inset="none" />
                                <Typography
                                    level='body-sm'
                                    fontWeight="bold">
                                    All Growth features, plus:
                                </Typography>
                                <ul className="">
                                    {helper.planU.features.map((feature: any) =>
                                        <li key={feature}>
                                            <Typography
                                                level='body-sm'>
                                                {feature}
                                            </Typography>
                                        </li>
                                    )}
                                </ul>
                                <Divider inset="none" />
                                {subscription.plan !== helper.planU.code &&
                                    <CardActions>
                                        <Button
                                            variant="outlined"
                                            color="neutral"
                                            sx={{
                                                backgroundColor: 'white'
                                            }}>
                                            Get a quote
                                        </Button>
                                    </CardActions>
                                }
                            </Card>
                        </div>
                    </div >
                    <div className='text-center mt-3 mb-3'>
                        <Typography level="body-sm">If you nee further information on our plans feel free to reach out to main@appinion.pt.</Typography>
                    </div>
                </>
            }
        </>
    );
}

export default PlanManagementComponent;